import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useWebSocket } from '../contexts/WebSocketContext';

// Connection status indicator component for navbar
function ConnectionStatusIndicator() {
  const { connectionState, isConnected, forceReconnect } = useWebSocket();
  
  // Define colors for different states
  const getStatusColor = () => {
    switch (connectionState) {
      case 'connected':
        return 'bg-green-500';
      case 'connecting':
        return 'bg-yellow-500';
      case 'reconnecting':
        return 'bg-yellow-500 animate-pulse';
      case 'disconnected':
      default:
        return 'bg-red-500';
    }
  };
  
  // Define tooltip text
  const getStatusText = () => {
    switch (connectionState) {
      case 'connected':
        return 'Connected to server';
      case 'connecting':
        return 'Connecting to server...';
      case 'reconnecting':
        return 'Reconnecting to server...';
      case 'disconnected':
      default:
        return 'Disconnected from server. Click to reconnect.';
    }
  };
  
  return (
    <div 
      className="relative cursor-pointer group flex items-center mr-2"
      onClick={() => !isConnected && forceReconnect()}
    >
      <div className={`w-3 h-3 rounded-full ${getStatusColor()} shadow-md mr-1.5`}></div>
      <span className="text-xs text-gray-600 hidden sm:inline">{connectionState}</span>
      <div className="absolute top-full right-0 bg-gray-800 text-white text-xs rounded px-2 py-1 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
        {getStatusText()}
      </div>
    </div>
  );
}

export default function Navbar({ buttons }) {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <h1 className="text-xl font-bold text-gray-900">
              FarmToHome Routing
            </h1>
            {buttons && (
              <div className="flex space-x-4">
                {buttons}
              </div>
            )}
          </div>
          <div className="flex items-center space-x-4">
            <ConnectionStatusIndicator />
            <span className="text-gray-700">
              {user?.displayName}
            </span>
            <button
              onClick={logout}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
